import { Box, TextField, Typography } from "@mui/material";

import useStyles from "./index.styles";

interface ProfileNameInputProps {
  profileName: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  validationMessage?: string;
}

export const ProfileNameInput = ({
  profileName,
  onChange,
  validationMessage,
}: ProfileNameInputProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.inputNameContainer}>
      <TextField
        placeholder="Input profile name"
        variant="standard"
        className={classes.inputBox}
        InputProps={{ disableUnderline: true }}
        value={profileName}
        onChange={onChange}
        autoComplete="off"
      />
      {validationMessage && (
        <Typography color="error" className={classes.validationMessage}>
          {validationMessage}
        </Typography>
      )}
    </Box>
  );
};
